declare global {
	interface Window {
		__navPrevScrollY?: number;
		__navStateInit?: boolean;
	}
}

const ATTRIBUTES = {
	hidden: 'data-nav-hidden',
	leaved: 'data-nav-leaved',
} as const;

const THRESHOLD = 300;

const read = (attribute: (typeof ATTRIBUTES)[keyof typeof ATTRIBUTES]) =>
	document.documentElement.getAttribute(attribute) !== null;

export const isNavHidden = () => read(ATTRIBUTES.hidden);

export const isNavLeaved = () => read(ATTRIBUTES.leaved);

const syncNavState = () => {
	const root = document.documentElement;
	const y = window.scrollY;
	const scrollingDown = y > (window.__navPrevScrollY ?? 0);
	const hidden = scrollingDown && isNavLeaved();
	window.__navPrevScrollY = y;
	root.toggleAttribute(ATTRIBUTES.hidden, hidden);
	root.toggleAttribute(ATTRIBUTES.leaved, y > THRESHOLD);
};

const initNavState = () => {
	if (typeof window === 'undefined' || window.__navStateInit) return;
	window.__navStateInit = true;
	window.addEventListener('scroll', syncNavState, { passive: true });
	syncNavState();
};

initNavState();
